module.exports = __webpack_public_path__ + "img/sevenday1-1.0445606e.jpg";